import { Component, Input } from '@angular/core'
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core'
import { CptDateAdapter, SharedTranslatePipe, TransifexTranslatePipe } from '@inside-hub-app/customer-portal-shared'
import { CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { TranslateService } from '@ngx-translate/core'
import {
  APP_DATE_FORMATS_1,
  SharedService
} from '../../../../services/shared.service'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { DatePipe, NgTemplateOutlet } from '@angular/common'
import { MatStepperPrevious } from '@angular/material/stepper'
import { MatDivider } from '@angular/material/list'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'customer-portal-app-appointments-popup-fourth-form',
  standalone: true,
  templateUrl: './appointments-popup-fourth-form.component.html',
  imports: [
    HubChildTranslateModule,
    DatePipe,
    NgTemplateOutlet,
    TransifexTranslatePipe,
    MatDivider,
    MatButton,
    MatStepperPrevious,
    SharedTranslatePipe,
    MatProgressSpinner
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: CptDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS_1
    }
  ]
})
export class AppointmentsPopupFourthFormComponent {
  @Input() appointmentsPopupService

  @Input() dialogRef

  dateLocale: string

  countryCode: string

  constructor(
    public sharedService: SharedService,
    public translateService: TranslateService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.countryCode = this.remoteConfigService.get('country.code')
    this.dateLocale = `${this.sharedService.currentLanguage()}-${this.countryCode.toUpperCase()}`
  }
}
